import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { isEmpty, forEach, get } from 'lodash';
import { Observable } from 'rxjs';
import { BACKEND_API_TYPE_FIELD_PATH } from '../constants';
import { observableThrowError, rx } from '../rx/rx-wrapper';
import { XEAHttpUrlEncodingCodec } from '../services/base/http-url-encoding-codec';
import { IServiceConfig } from '../services/base/service-config.type';
import { IFilterQuery } from '../types/common/filter-query.type';
import { BackendApiType } from '../types/enums/backend-api-type.enum';

export const createRequestParams = ({
  filter,
  select: selectArg,
  top,
  skip,
  orderby,
  expand,
  effectiveDate,
  include_entities,
  include_nested_type,
  customParams,
  config,
  from_site,
  include_mappings,
  ...queryParams
}: IFilterQuery & { config?: Partial<IServiceConfig> } = {}): HttpParams => {
  let params = new HttpParams({ encoder: new XEAHttpUrlEncodingCodec() });

  // add fixed BACKEND_API_TYPE_FIELD_PATH params, will remove by url.interceptor
  if (!isEmpty(config)) {
    params = params.set(
      BACKEND_API_TYPE_FIELD_PATH,
      config?.backendApiType ?? BackendApiType.XEA,
    );
  }

  if (from_site) {
    params = params.set('from_site', from_site);
  }

  // TODO find better solution for handling params
  if (filter) {
    params = params.set('$filter', filter);
  }
  if (!isEmpty(selectArg)) {
    params = params.set('$select', selectArg.toString());
  }
  if (top) {
    params = params.set('$top', top.toString());
  }
  if (skip) {
    params = params.set('$skip', skip.toString());
  }
  if (orderby) {
    params = params.set('$orderby', orderby.toString());
  }
  forEach(queryParams, (param, key) => {
    params = params.set(key, param.toString());
  });
  if (include_entities) {
    const entityList: string = include_entities
      .map((entityType) => `'${entityType}'`)
      .join(',');
    params = params.set('include_entities', `[${entityList}]`);
  }
  if (include_nested_type) {
    const typeList: string = include_nested_type
      .map((type) => `'${type}'`)
      .join(',');
    params = params.set('include_nested_type', `[${typeList}]`);
  }
  if (customParams) {
    customParams.map(({ key, value }) => {
      params = params.set(key, String(value));
    });
  }
  if (expand) {
    params = params.set('$expand', expand.toString());
  }
  if (effectiveDate) {
    params = params.set('effective_date', effectiveDate);
  }
  if (include_mappings) {
    params = params.set('include_mappings', include_mappings.toString());
  }

  return params;
};

export const catchHttpErrorAndPickErrorList =
  (): any =>
  <T>(input$: Observable<T>): Observable<T> =>
    input$.pipe(
      rx.catchError(({ error }: HttpErrorResponse) =>
        observableThrowError(get(error, 'errors')),
      ),
    );
